import { BenefitDTOBenefitEnum, DocumentsDTO, TenantDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class CouponsBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ tenant, documents }: { tenant: TenantDTO; documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Coupons.toLowerCase();
    const giftRoutes = tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Gifts)
      ? [
          {
            title: 'couponsModule:giftsPage.subTitle',
            to: `/benefits/${benefit}/gifts`,
          },
          {
            title: 'couponsModule:incentivesPage.subTitle',
            to: `/benefits/${benefit}/incentives`,
          },
        ]
      : [];
    const creditCardRoutes = tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.CreditCard)
      ? [
          {
            title: 'CREDIT_CARD.title',
            to: `/benefits/${benefit}/creditCards`,
            hasSubpages: true,
          },
        ]
      : [];
    const wellpassRoutes = tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Wellpass)
      ? [
          {
            title: 'WELLPASS.title',
            to: `/benefits/${benefit}/wellpass`,
            hasSubpages: true,
          },
        ]
      : [];
    const couponRoutes = tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.Coupons)
      ? [
          {
            title: 'subPage.settings',
            to: `/benefits/${benefit}/settings`,
          },
        ]
      : [];

    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      { title: 'couponsModule:budgetPage.subTitle', to: `/benefits/${benefit}/transactions` },
      ...giftRoutes,
      ...creditCardRoutes,
      ...wellpassRoutes,
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
      ...couponRoutes,
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
